export enum ConfigOptionTypeEnum {
    STATUS_ATIVIDADES = "status-atividades",
    PRIORIDADE_ATIVIDADES = 'prioridade-atividades',
}